exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/author-course-integrations.js-WebpackMultiOutput";